import { render, staticRenderFns } from "./GovMenuSetting.vue?vue&type=template&id=025e46f5&scoped=true&"
import script from "./GovMenuSetting.vue?vue&type=script&lang=js&"
export * from "./GovMenuSetting.vue?vue&type=script&lang=js&"
import style0 from "./GovMenuSetting.vue?vue&type=style&index=0&id=025e46f5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025e46f5",
  null
  
)

export default component.exports